<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div id="app" class="container-fluid no-padding-right">
        <div class="row justify-content-center">
            <div :class="['col-12 app-wrapper p-0', { 'show-chat': showChatMobile }]">

                <div class="col-md-4 col-lg-3 side-panel p-0">
                    <div class="header-panel">
                        <img :src="avata_profile" class="rounded-circle" width="40" :title="name_user">
                        <div>
                            <button class="btn btn-success btn-sm" @click="showModalEditDirectory"><i
                                    class="fa fa-plus"></i> Nova conversa</button>
                        </div>
                    </div>
                    <div class="contacts-scroll">
                        <div v-for="(contact, index) in contacts" :key="index"
                            :class="['contact-box', { active: activeContactIndex === index }]">
                            <img :src="contact.photo" class="rounded-circle mr-3" width="45" v-if="contact.photo != ''"
                                @click="selectContact(contact, index)">
                            <img :src="getAvatarUrl(contact.name, contact.pic)" class="rounded-circle mr-3" width="45"
                                v-else @click="selectContact(contact, index)">
                            <div class="w-100" @click="selectContact(contact, index)">
                                <h6 class="mb-0">{{ contact.name }} <i v-if="contact.group" class="fa fa-users"
                                        title="Grupo"></i> <span class="badge badge-success" :id="contact.id"
                                        style="display:none;"><small>Novas mensagens</small></span></h6>
                                <small>Última atualização: {{ contact.updated_at }}</small>
                            </div>

                            <div class="btn-group" role="group">
                                <button id="btnGroupDrop1" type="button" class="btn btn-link btn-sm dropdown-toggle"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  
                                </button>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                    <a class="dropdown-item" href="#" @click="showModalUpdateName(contact)">Editar</a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h6 class="text-center" v-if="contacts.length <= 0">Sem mensagens no momento...</h6>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 col-lg-9 main-chat p-0">
                    <div class="header-panel border-left">
                        <div class="d-flex align-items-center">
                            <div class="Última atualização" v-if="contact != null">
                                <small>Última atualização: {{ contact.updated_at }}</small>
                            </div>
                            <button class="btn d-md-none mr-2" @click="showChatMobile = false">
                                <i class="fas fa-arrow-left"></i>
                            </button>
                            <!-- <img :src="getAvatarUrl(activeContact.name, activeContact.pic)" class="rounded-circle mr-3"
                                width="40"> -->
                            <!-- <div>
                                <h6 class="mb-0">{{ activeContact.name }}</h6>
                                <small class="text-muted">{{ activeContact.status }}</small>
                            </div> -->
                        </div>
                    </div>

                    <div class="chat-messages" ref="chatWindow">
                        <div v-for="(msg, index) in messages" :key="index"
                            :class="['msg', msg.origin === 'sent' ? 'sent' : 'received']">
                            <span v-if="msg.type_message == 'text'" v-html="msg.text"></span>
                            <audio v-else-if="msg.type_message == 'audio'" ref="audioPlayer" :src="msg.file_url"
                                controls></audio>
                            <div class="msg has-image" :class="['msg', msg.origin === 'sent' ? 'sent' : 'received']"
                                v-else-if="msg.type_message == 'image'">
                                <small class="d-block font-weight-bold mb-1" style="color: #0D8ABC;">Imagem</small>
                                <a :href="msg.file_url" target="_blank"><img :src="msg.file_url" class="msg-img"></a>
                                <div class="d-flex justify-content-between align-items-center mt-1 px-1">
                                    <small class="text-muted" style="font-size: 10px;">{{ msg.file_extension }} • {{
                                        msg.file_size }}MB </small>
                                </div>
                            </div>
                            <div class="msg msg-received has-video" v-else-if="msg.type_message == 'video'">
                                <small class="d-block font-weight-bold mb-1" style="color: #e91e63;">Vídeo</small>
                                <video class="msg-video" controls>
                                    <source :src="msg.file_url" type="video/mp4">
                                    Seu navegador não suporta vídeos.
                                </video>
                                <div class="d-flex justify-content-between align-items-center mt-1 px-1">
                                    <small class="text-muted" style="font-size: 10px;">{{ msg.file_extension }} • {{
                                        msg.file_size }}MB </small>
                                </div>
                            </div>
                            <div class="msg msg-received" v-else-if="msg.type_message == 'document'">
                                <small class="d-block font-weight-bold mb-1" style="color: #0D8ABC;">Arquivo</small>
                                <a :href="msg.text" download="${fileName}" class="msg-file-container" target="_blank">
                                    <div class="file-icon">
                                        <i class="fas fa-file-pdf"></i>
                                    </div>
                                    <div class="file-info">
                                        <span class="file-name">{{ msg.file_extension }}</span>
                                        <span class="file-size">{{ msg.file_size }}MB</span>
                                    </div>
                                    <div class="download-icon">
                                        <i class="fas fa-download"></i>
                                    </div>
                                </a>
                            </div>
                            <div class="text-muted d-block text-right"><small>{{ msg.created_at }}</small></div>
                        </div>
                    </div>

                    <div class="chat-footer">
                        <input type="text" v-model="newMessage" @keyup.enter="sendMessage"
                            class="form-control border-0 mr-2" placeholder="Digite uma mensagem..."
                            :disabled="input_text">
                        <button class="btn btn-light" @click="sendMessage" :disabled="input_text">
                            <i class="fas fa-paper-plane text-success"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="modalDisplayNewContact" class="modal" :style="{ display: modalDisplayNewContact }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewContact">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newDirectoryLabel">Adicionar novo contato</h5>
                            <button type="button" class="close" @click="closeModalNewContact()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Telefone do contato</label>
                                    <input type="text" class="form-control" placeholder="Ex: (xx)9.xxxx-xxxx"
                                        v-model="phone_new_contact" v-mask="['(##) ####-####', '(##) #####-####']">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalNewContact()"><i
                                    class="fa fa-ban"></i> Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory"
                                :disabled='!isDisabledNewContact'><i class="fa fa-check"></i>
                                Abrir conversa</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayUpdateChat" class="modal" :style="{ display: modalDisplayUpdateChat }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateChatName">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newDirectoryLabel">Atualizar nome</h5>
                            <button type="button" class="close" @click="closeModalUpdateName()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Nome</label>
                                    <input type="text" class="form-control" placeholder="Informe um nome para a conversa"
                                        v-model="name_chat">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalUpdateName()"><i
                                    class="fa fa-ban"></i> Cancelar</button>
                            <button type="submit" class="btn btn-info saveDirectory"
                                :disabled='!isDisableUpdateChat'><i class="fa fa-check"></i>
                                Atualizar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import Loading from 'vue-loading-overlay';
import { handleRequestErrors } from '@/handleErrors';
import { mask } from 'vue-the-mask'


export default {
    directives: { mask },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            avata_profile: '',
            name_user: '',
            input_text: true,
            activeContactIndex: 0,
            showChatMobile: false,
            newMessage: '',
            contact: null,
            contacts: [],
            loadChat: null,
            loadChatMessage: null,
            messages: [{ text: 'Olá! Selecione um contato para conversar.', type: 'received', type_message: 'text' }],
            total_messages_chat: [],
            modalDisplayNewContact: 'none',
            modalDisplayUpdateChat: 'none',
            phone_new_contact: '',
            time_chat: [],
            name_chat:'',
            chat_id:'',
            request_chat_api: false
        }
    },
    computed: {
        activeContact() {
            return this.contacts[this.activeContactIndex];
        },
        isDisabledNewContact: function () {
            return this.phone_new_contact != '';
        },
         isDisableUpdateChat: function () {
            return this.name_chat != '';
        },
    },
    mounted() {
        this.getAvatarProfile();
        this.getChat();
        this.loadChat = setInterval(() => this.getChat(), 15000);

    },
    beforeUnmount() {
        clearInterval(this.loadChat);
        clearInterval(this.loadChatMessage);
        this.loadChat = null;
        this.loadChatMessage = null;
    },
    methods: {
        getAvatarProfile() {
            const name = localStorage.getItem('name');
            this.name_user = name;
            this.avata_profile = 'https://ui-avatars.com/api/?name=' + name + '&background=007bff&color=fff';
        },
        viewTotalMessagesChat() {
            const keyToCheck = "id";
            this.contacts.forEach(contact => {
                const span_new_message = document.getElementById(contact.id);
                const keyExistsInArray = this.total_messages_chat.some(obj => Object.keys(obj).includes(keyToCheck));
                if (keyExistsInArray) {
                    const filteredData = this.total_messages_chat.filter(item => item.id === contact.id);
                    if (filteredData[0].total != contact.messages.length) {
                        span_new_message.style.display = 'inline';
                    }
                } else {
                    span_new_message.style.display = 'none';
                    this.total_messages_chat.push({ 'id': contact.id, 'total': contact.messages.length })
                }
            });

        },

        getChat() {
            api.get('/whatsapp/chat')
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    this.contacts = response.data.data;
                    this.viewTotalMessagesChat();
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })

        },
        getChatMessage() {
            api.get('/whatsapp/chat/' + this.contact.id)
                .then((response) => {
                    this.messages = [];
                    this.messages = response.data.data;
                    this.scrollToBottom();
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })

        },
        selectContact(contact, index) {
            this.contact = contact;
            this.activeContactIndex = index;
            this.showChatMobile = true;
            this.messages = [];
            this.messages = contact.messages;
            this.scrollToBottom();
            this.input_text = false;
            clearInterval(this.loadChatMessage);
            this.loadChatMessage = null;
            this.loadChatMessage = setInterval(() => this.getChatMessage(), 20000);
            //Atualizar total chat
            const index_chat = this.total_messages_chat.findIndex(item => item.id === contact.id);
            if (index_chat !== -1) {
                this.total_messages_chat[index_chat].total = contact.messages.length;
                const span_new_message = document.getElementById(contact.id);
                span_new_message.style.display = 'none';
            }

        },
        sendMessage() {
            if (this.newMessage.trim() !== '') {
                const message = this.newMessage.trim();
                this.messages.push({
                    text: message,
                    origin: 'sent',
                    type_message: 'text'
                });
                this.newMessage = '';
                this.scrollToBottom();

                const formData = new FormData();
                formData.append('message', message);
                api.post('/whatsapp/message/' + this.contact.id, formData)
                    .then(() => {

                    }).catch(error => {
                        this.isLoading = false;
                        handleRequestErrors(error.status);
                    })


            }
        },
        getAvatarUrl(name, color) {
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=${color}&color=fff`;
        },
        scrollToBottom() {
            // O nextTick garante que o DOM foi atualizado antes de rolar
            this.$nextTick(() => {
                const container = this.$refs.chatWindow;
                container.scrollTop = container.scrollHeight;
            });
        },
        createNewContact(event) {
            event.preventDefault();
            this.isLoading = true;
            api.post('/whatsapp/chat', { 'phone': this.phone_new_contact })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Nova conversa aberta!",
                        type: 'success'
                    });
                    this.getChat();
                    this.closeModalNewContact();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewContact();
                    handleRequestErrors(error.status, error);
                })
        },
        updateChatName(event) {
            event.preventDefault();
            this.isLoading = true;
            api.post('/whatsapp/changeName/'+this.chat_id, { 'name': this.name_chat })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Conversa atualizada com sucesso!",
                        type: 'success'
                    });
                    this.closeModalUpdateName();
                     this.getChat();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalUpdateName();
                    handleRequestErrors(error.status, error);
                })
        },
        showModalEditDirectory() {
            this.modalDisplayNewContact = 'block';
        },
        closeModalNewContact() {
            this.modalDisplayNewContact = 'none';
            this.phone_new_contact = '';
        },

        showModalUpdateName(contact) {
            this.modalDisplayUpdateChat = 'block';
            this.name_chat = contact.name;
            this.chat_id = contact.id
        },
        closeModalUpdateName() {
            this.modalDisplayUpdateChat = 'none';
        },
    }
}
</script>

<style>
.app-wrapper {
    height: calc(80vh - 40px);
    background-color: #f0f2f5;
    display: flex;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
}

.side-panel {
    background-color: #fff;
    border-right: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.contacts-scroll {
    overflow-y: auto;
    flex: 1;
}

.contact-box {
    display: flex;
    padding: 12px;
    cursor: pointer;
    border-bottom: 1px solid #f2f2f2;
}

.contact-box:hover {
    background-color: #f5f5f5;
}

.contact-box.active {
    background-color: #ebebeb;
}

.main-chat {
    background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');
    background-color: #e5ddd5;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.header-panel {
    background-color: #ededed;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 60px;
}

.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.msg {
    max-width: 100%;
    padding: 8px 12px;
    border-radius: 7px;
    margin-bottom: 8px;
    font-size: 14px;
    box-shadow: 0 1px 0.5px rgba(0, 0, 0, .13);
}

.received {
    background-color: #fff;
    align-self: flex-start;
    overflow-wrap: break-word;
}

.sent {
    background-color: #dcf8c6;
    align-self: flex-end;
    overflow-wrap: break-word;
}

.chat-footer {
    background-color: #f0f0f0;
    padding: 10px 15px;
    display: flex;
    align-items: center;
}

.msg-img {
    width: 100%;
    max-height: 250px;
    object-fit: cover;
    border-radius: 4px;
    display: block;
    cursor: pointer;
    transition: filter 0.2s;
}

.msg-img:hover {
    filter: brightness(0.9);
}

.msg.has-image {
    padding: 4px !important;
    width: 250px;
}

.msg-video {
    width: 100%;
    max-height: 250px;
    border-radius: 4px;
    background-color: #000;
    display: block;
}

.msg.has-video {
    padding: 4px !important;
    width: 280px;
    background-color: #fff;
}

/* Estilo para mensagens de arquivo/documento */
.msg-file-container {
    display: flex;
    align-items: center;
    background-color: #f0f2f5;
    padding: 10px;
    border-radius: 6px;
    text-decoration: none !important;
    color: inherit !important;
    transition: background-color 0.2s;
}

.msg-file-container:hover {
    background-color: #e6e6e6;
}

.file-icon {
    font-size: 24px;
    color: #727abe;
    /* Cor padrão para ícones de arquivo */
    margin-right: 12px;
}

.file-info {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
}

.file-name {
    font-weight: 500;
    font-size: 13px;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
}

.file-size {
    font-size: 11px;
    color: #667781;
}

.download-icon {
    font-size: 18px;
    color: #8696a0;
    margin-left: 10px;
}

.no-padding-right{
    padding-right: 0px;
}

@media (max-width: 768px) {
    .side-panel {
        width: 100%;
        position: absolute;
        z-index: 2;
    }

    .main-chat {
        width: 100%;
        position: absolute;
        z-index: 1;
    }

    .show-chat .main-chat {
        z-index: 3;
    }
}
</style>